module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "zk-dialog__wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.handleWrapperClick($event)
      }
    }
  }, [_c('div', {
    ref: "dialog",
    staticClass: "zk-dialog",
    class: [_vm.sizeClass, _vm.customClass],
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "zk-dialog__header"
  }, [_c('span', {
    staticClass: "zk-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "zk-dialog__headerbtn"
  }, [_c('i', {
    staticClass: "zk-dialog__close zk-icon zk-icon-close",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })])]), _vm._v(" "), (_vm.rendered) ? _c('div', {
    staticClass: "zk-dialog__body"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "zk-dialog__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-c1907582"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/dialog/src/dialog.vue
// module id = 282
// module chunks = 0